// Compact annotations must fit their declared box. Keep this dependency-free
// contract identical in backend/utils and frontend/constants/utils; parity is tested.
// This conservative fallback estimates wrapping; it does not typeset arbitrary fonts.
function fitCompactSlideText(element) {
    if (element?.type !== 'text' || !['body', 'subtitle', 'caption'].includes(element.role)
        || element.preserveTypography || !(element.h > 0 && element.h <= 1.2)
        || !(element.w > 0) || !element.text || !Number.isFinite(element.fontSize)
        || element.fontSize <= 12) return element;
    const width = Math.max(1, element.w * 72 - 12);
    const height = Math.max(1, element.h * 72 - 12);
    const wrappedLines = size => String(element.text).split('\n').reduce((total, paragraph) => {
        let lines = 1, used = 0;
        for (const word of paragraph.trim().split(/\s+/).filter(Boolean)) {
            const wordWidth = [...word].reduce((sum, char) => sum +
                (/[^\u0000-\u024f]/u.test(char) ? size : size * 0.56), 0);
            const gap = used ? size * 0.56 : 0;
            if (used && used + gap + wordWidth > width) { lines++; used = 0; }
            else used += gap;
            if (wordWidth > width) {
                lines += Math.ceil(wordWidth / width) - 1;
                used = wordWidth % width || width;
            } else used += wordWidth;
        }
        return total + lines;
    }, 0);
    let size = element.fontSize;
    while (size > 12 && wrappedLines(size) * size * 1.32 > height) size = Math.max(12, size - 1);
    return size < element.fontSize
        ? { ...element, fontSize: size, preserveTypography: true } : element;
}

module.exports = { fitCompactSlideText };
